import React from "react";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function NavbarFromSidebar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
              Admin Menu
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin">
                  Students
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-instructor-list">
                  Instructors
                </NavLink>
              </li>
              {/*}
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-taskmanage">
                  Task Manager
                </NavLink>
              </li>
              */}
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/admin/admin-counselorcorner/0/Admin"
                >
                  Private Note
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-params">
                  Parameters
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-booklist">
                  BookList
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-class">
                  Class
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-desiredcolleges">
                  Desired Colleges
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/admin/admin-progress-check">
                  Progress Check
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}
